function n() {
  if (typeof Node == "function" && Node.prototype) {
    const t = Node.prototype.removeChild;
    Node.prototype.removeChild = function(e) {
      return e.parentNode !== this ? (console && console.error("Cannot remove a child from a different parent", e, this), e) : t.apply(this, arguments);
    };
    const r = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function(e, o) {
      return o && o.parentNode !== this ? (console && console.error(
        "Cannot insert before a reference node from a different parent",
        o,
        this
      ), e) : r.apply(this, arguments);
    };
  }
}
export {
  n as fixFailedToExecuteRemoveChildOnNode
};
